import { Component, OnInit } from "@angular/core";
import { ContactService } from "../../_services/contact.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
declare var jQuery: any;
import "../../../assets/semantic/semantic.min.js";
import { CompanyService } from "../../_services/company.service";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.css"],
})
export class ContactComponent implements OnInit {
  // page param (stored in URL)
  private page_param: string;

  // for table
  private contacts: object[];
  private contacts_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];
  private companies: object[];

  private nothing_found: boolean = false;

  constructor(
    private service: ContactService,
    private company_service: CompanyService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  filters = new FormGroup({
    email: new FormControl(""),
    company: new FormControl(""),
    name: new FormControl(""),
    phone: new FormControl(""),
  });

  ngOnInit() {
    // this.company_service.autocompleteCompanies('').subscribe(response => {
    //   this.companies = response;
    // });

    // Get the Params..
    this.route.queryParams.subscribe((params) => {
      this.page_param = params["page"] || 1; // Get Page number Param
    });

    // this.filters.patchValue({company: '2'});
    this.filters.valueChanges.debounceTime(500).subscribe((value) => {
      this.router.navigate(["/contacts"], { queryParams: { page: "1" } });
      this.refresh();
    });

    this.refresh();
  }

  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_param });
    this.service
      .getContacts(params) // Get Contacts List
      .subscribe((response) => {
        //console.log(response);
        this.contacts = response.contacts; // Contact Page List
        this.contacts_count = parseInt(response.total_count); // Contact Count
        this.page_number = parseInt(response.page); // Current Page
        this.page_count = Math.ceil(this.contacts_count / 25); // Page Count
        // Page Indicators (for ngFor iterations)
        if (this.page_count < 10) {
          this.page_indicators = Array(this.page_count).fill(1);
        } else {
          this.page_indicators = Array(10).fill(1);
        }
      });
  }

  // Previous Page Button
  previousPage() {
    this.router
      .navigate(["/contacts"], { queryParams: { page: this.page_number - 1 } })
      .then(
        function () {
          this.refresh();
        }.bind(this)
      );
  }

  // Next Page Button
  nextPage() {
    this.router
      .navigate(["/contacts"], { queryParams: { page: this.page_number + 1 } })
      .then(
        function () {
          this.refresh();
        }.bind(this)
      );
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.router.navigate(["/contacts"], { queryParams: { page: nb } }).then(
      function () {
        this.refresh();
      }.bind(this)
    );
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/contact/contact.component.ts